export const URL_CONFIG = {
    STATUS_TRACKING: {
        en: "https://status.medfarsolutions.com",
        fr: "https://statut.medfarsolutions.com",
        es: "https://estatus.medfarsolutions.com"
    },
    REMOTE_ACCESS: {
        windows: "https://download.teamviewer.com/download/version_15x/TeamViewerQS_en.exe",
        mac: "https://download.teamviewer.com/download/version_15x/TeamViewerQS.dmg"
    },
    HELP_SITE: "https://medfar.my.site.com/s/",
    CAMPAIGN_CONTENT: "https://demo.medfarsolutions.com/content/CampaignImages"
} as const;
